import { TREINSERIES_QUERY_KEY } from "@/entities/treinserie/constants.ts";
import { useApiClient } from "@/infrastructure/rest";
import { TreinseriesDto } from "@/shared/types";
import { usePrefetchQuery, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { Treinserie } from "./domain";

export function useGetTreinseries<T = Treinserie[]>(options?: Omit<UseQueryOptions<Treinserie[], Error, T>, "queryFn" | "queryKey">) {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [TREINSERIES_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<TreinseriesDto>("/infra/treinseries");
            return data?.treinseries.map((dto) => Treinserie.fromDto(dto))?.sort(Treinserie.sort) ?? [];
        },
        ...options,
    });
}

export function usePrefetchTreinseriesForToday() {
    const apiClient = useApiClient();

    usePrefetchQuery({
        queryKey: [TREINSERIES_QUERY_KEY, new Date().toDateString()],
        queryFn: async () => {
            const data = await apiClient.get<string[]>("/infra/treinseries/vandaag");
            return data?.sort((a: string, b: string): number => parseInt(a) - parseInt(b)) ?? [];
        },
    });
}

export function useGetTreinseriesForToday() {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [TREINSERIES_QUERY_KEY, new Date().toDateString()],
        queryFn: async () => {
            const data = await apiClient.get<string[]>("/infra/treinseries/vandaag");
            return data?.sort((a: string, b: string): number => parseInt(a) - parseInt(b)) ?? [];
        },
    });
}

export function useGetLijnnummerForTreinserie(treinserie: string | number) {
    return useGetTreinseries({
        select: (data): string | number | undefined => {
            return data.find((ts) => {
                if (ts.treinNummerVan === treinserie) return true;
                const treinserieNummer = typeof treinserie === "string" ? parseInt(treinserie) : treinserie;
                const [van, tot] = [parseInt(ts.treinNummerVan), parseInt(ts.treinNummerTot)];
                return van <= treinserieNummer && tot >= treinserieNummer;
            })?.lijnnummer;
        },
    });
}
